<template>
  <div id="contact" class="o-contact">
    <div class="o-container">
      <div class="o-contact__inner">
        <div class="o-contact__header">
          <h3 class="o-contact__title">Contact us today</h3>
          <p class="o-contact__intro">Whether you have a question, observation or general comment about our annual review - we would love to hear from you.</p>
        </div>

        <p><a :href="`mailto:${$globals.contact}`" class="c-button c-button--icon">
          <span class="c-button__icon"><svg class="c-icon c-icon--envelop3"><use xlink:href="#icon-envelop3"></use></svg></span>
          <span class="c-button__text">Send us your feedback</span>
        </a></p>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyContact'
}
</script>



// WEBPACK FOOTER //
// src/components/objects/MyContact.vue